import * as types from "../../types/stores.types";

const initialState = {
    status_show_modal: false,
    loader_modal: false,
    codes: []
}
const modalMyDiscounts = (state = initialState, action) => {
    switch (action.type) {
        case types.CHANGE_STATUS_SHOW_MODAL_MY_DISCOUNTS:
            return {...state, status_show_modal: action.payload.status_show_modal};
        case types.CHANGE_LOADER_MODAL_MY_DISCOUNT:
            return {...state, loader_modal: action.payload.loader_modal};
        case types.PUT_SET_MY_DISCOUNTS:
            return {...state, codes: action.payload.codes};
        default:
            return state;
    }
}

export default modalMyDiscounts;